module.exports = __webpack_public_path__ + "static/img/tips-for-buy-ev-car.6665962.jpg";